
import { defineComponent } from 'vue';
import { PersianDate } from '@/Utils/persian-date';

export default defineComponent({
    name: "withdrawalTransactionsTableComponent",

    props: ["transactions"],

    data() {
        return {
            persianDateConverter: new PersianDate(),
            tableHeaders: [
                "تاریخ و ساعت",
                "توضیحات",
                "وضعیت",
                "شماره کارت",
                "نام و نام خانوادگی",
                "شماره شبا",
                "مبلغ (تومان)",
            ],
        }
    },

    methods: {
        persianDate(utcDateTime: string): string {
            return this.persianDateConverter.convert(utcDateTime, true);
        },

        FormatPersianAmount(amount: number | string): string {
            // Convert to number if it's a string
            const num = typeof amount === 'string' ? parseFloat(amount) : amount;

            if (isNaN(num)) {
                return "مبلغ نا معتبر"; // Or handle the error as you prefer
            }

            const parts = num.toString().split(".");
            const integerPart = parts[0];
            const fractionalPart = parts[1] || '';

            // Apply thousands separator to the integer part
            const formattedIntegerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

            // Combine integer and fractional parts
            const formattedAmount = fractionalPart ? `${formattedIntegerPart}.${fractionalPart}` : formattedIntegerPart;

            return formattedAmount;
        },
    },
})
